<template>
    <div class="Login container-fluid">

        <div class="row justify-content-center">
            <div class="col-12 col-md-8 col-lg-5 col-xl-3 text-center">
                <div v-if="showError" class="shadow white bg-white rounded-10 p-4 mt-4">

                    <!-- Form -->
                    <h1>{{ $t('confirmEmail.confirmationFailed') }}</h1>

                    <p>{{ $t('confirmEmail.contactUsToResolve') }}</p>

                    <router-link :to="{ name: 'Home' }" class="">{{ $t('confirmEmail.visitHomePage') }}</router-link>

                </div>
                <div v-else-if="!showConfirmation" class="shadow white bg-white rounded-10 p-4 mt-4">

                    <!-- Form -->
                    <h1>{{ $t('confirmEmail.confirmingEmail') }}</h1>

                    <p>{{ $t('confirmEmail.pleaseWaitConfirm') }}</p>

                </div>
                <div v-else-if="showConfirmation" class="shadow white bg-white rounded-10 p-4 mt-4">

                    <!-- Form -->
                    <h1>{{ $t('confirmEmail.confirmationSuccess') }}</h1>

                    <p>{{ $t('confirmEmail.redirectInProgress') }}</p>

                    <router-link :to="{ name: 'Login' }" class="">{{ $t('confirmEmail.forceRedirect') }}</router-link>

                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'ConfirmEmail',
        components: {
        },
        props: {

        },
        data: function () {

            return {
                Model: {
                    UserID: '',
                    Code: ''
                },
                showConfirmation: false,
				showError: false,
				lstErrors: []
            }

        },
        mounted: function () {
            this.Model.Code = this.$route.query.code
            this.Model.UserID = this.$route.query.userID

            this.ConfirmEmail();

        },
        methods: {
            ConfirmEmail: function () {

                axios({
                    method: 'post',
					url: '/account/ConfirmEmail',
					data: this.Model
                })
                    .then((response) => {

                        //Force check for login status
                        this.$store.commit('SET_loginStatusActual', false)

                        if (response.data.succeeded) {
                            this.showConfirmation = true

							setTimeout(() => {
								this.$router.push({ name: 'Login' })
							}, 3000);


                        } else {
                            this.showError = true
                            this.lstErrors = response.data.errors
                        }

                        this.MethodResponse = response.data;
                    })
                    .catch((error) => {
                        this.MethodResponse = error;
                    });
            }
        },
        computed: {
            
        }
    }
</script>